(function () {
  "use strict";
  const form = document.getElementById("SolariiInquiryForm");
  if (!form) return;
  const pendingKey = "solarii-pending-inquiry-v1";
  const receiptKey = "solarii-inquiry-receipt-v1";
  const lifetime = 30 * 60 * 1000;
  const imageOrigin = "https://solarii-custom-image-upload.moneycash70q.chatgpt.site";
  let result = {};
  try { result = JSON.parse(document.getElementById("solarii-inquiry-result").textContent); } catch {}
  let sending = false;
  let pending;
  try {
    const value = JSON.parse(sessionStorage.getItem(pendingKey));
    if (value && value.version === 1 && value.path === location.pathname &&
        value.expiresAt > Date.now() && typeof value.brief === "string") pending = value;
    else sessionStorage.removeItem(pendingKey);
  } catch {}
  function readReceipt() {
    try {
      const value = JSON.parse(sessionStorage.getItem(receiptKey));
      if (value?.version === 1 && value.path === location.pathname && value.expiresAt > Date.now() &&
          /^SQ-[A-F0-9]{8}$/.test(value.reference) && typeof value.email === "string" &&
          Number.isInteger(value.imageCount) && value.imageCount >= 0 && value.imageCount <= 3) return value;
    } catch {}
    return null;
  }
  const returned = new URL(location.href).searchParams;
  let receipt = readReceipt();
  // Only Shopify's successful return for this tab's pending submission creates a receipt.
  // A hash, a pending draft, or a success query parameter alone must never report success.
  if (!result.error && result.posted === true && pending?.stage === "submitting" &&
      pending.returnToken && returned.get("sq_return") === pending.returnToken) {
    receipt = { version: 1, path: location.pathname, expiresAt: Date.now() + 24 * 60 * 60 * 1000,
      reference: pending.reference, email: pending.state.contactEmail,
      imageCount: pending.state.photos.length };
    try { sessionStorage.setItem(receiptKey, JSON.stringify(receipt)); } catch {}
  }
  let success = !!receipt;
  function showReceipt() {
    if (!receipt) return;
    success = true;
    sending = false;
    pending = undefined;
    try { sessionStorage.removeItem(pendingKey); } catch {}
    window.SolariiUploads?.clearSavedSession();
    document.getElementById("root")?.setAttribute("hidden", "");
    const section = document.getElementById("solarii-inquiry-success");
    if (!section) return;
    section.hidden = false;
    const values = { "sq-receipt-reference": receipt.reference, "sq-receipt-email": receipt.email,
      "sq-receipt-images": String(receipt.imageCount) };
    for (const [id, value] of Object.entries(values)) {
      const element = document.getElementById(id);
      if (element) element.textContent = value;
    }
    section.focus();
  }
  if (success) showReceipt();
  document.getElementById("sq-start-another-inquiry")?.addEventListener("click", () => {
    try { sessionStorage.removeItem(receiptKey); sessionStorage.removeItem(pendingKey); } catch {}
    const clean = new URL(location.href);
    clean.searchParams.delete("contact_posted");
    clean.searchParams.delete("sq_return");
    clean.searchParams.delete("form_type");
    clean.hash = "";
    location.replace(clean.pathname + clean.search);
  });

  function validImage(photo) {
    if (photo.status !== "ready" || typeof photo.remoteUrl !== "string") return false;
    try {
      const url = new URL(photo.remoteUrl);
      if (url.username || url.password) return false;
      return (url.origin === imageOrigin && /^\/api\/files\/[a-f0-9-]+\/[a-f0-9]{64}$/.test(url.pathname)) ||
        (url.origin === "https://cdn.shopify.com" && /^\/s\/files\/1\/0642\/6941\/8596\/files\/solarii-inquiry-[a-f0-9-]{36}\.(png|jpg|webp)$/.test(url.pathname));
    } catch { return false; }
  }

  function restore() {
    if (success || !pending?.state) return null;
    const state = pending.state;
    if (!["adapt", "reference", "curated"].includes(state.route) ||
        !Array.isArray(state.photos) || state.photos.length > 3 ||
        (state.route === "reference" && !state.photos.every(validImage))) return null;
    return { ...state, photos: state.photos.map(photo => ({ ...photo, url: photo.remoteUrl })) };
  }

  function save(value) {
    pending = value;
    try { sessionStorage.setItem(pendingKey, JSON.stringify(value)); } catch {}
  }

  async function submit(state, brief) {
    if (success || sending) throw new Error("This inquiry is already being submitted.");
    const email = String(state.contactEmail || "").trim();
    const phone = String(state.contactPhone || "").trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email) || email.length > 254) {
      throw new Error("Please enter a valid email address before submitting.");
    }
    const digits = phone.replace(/\D/g, "");
    if (phone && (!/^\+?[\d ().-]+$/.test(phone) || digits.length < 7 || digits.length > 15)) {
      throw new Error("Please check your phone number.");
    }
    const photos = state.route === "reference" ? state.photos : [];
    if (photos.length > 3 || !photos.every(validImage)) throw new Error("Please wait until every reference image has uploaded.");
    if (typeof brief !== "string" || brief.length < 20 || brief.length > 20000) throw new Error("Please review your inquiry before submitting.");
    const action = new URL(form.action, location.href);
    if (action.origin !== location.origin || !action.pathname.endsWith("/contact")) throw new Error("The inquiry form is unavailable. Please reload this page.");
    sending = true;
    try {
      const reference = pending?.brief === brief ? pending.reference : "SQ-" + crypto.randomUUID().slice(0, 8).toUpperCase();
      const savedState = { ...state, contactEmail: email, contactPhone: phone,
        photos: photos.map(photo => ({ id: photo.id, name: photo.name, remoteUrl: photo.remoteUrl, url: photo.remoteUrl, status: "ready", progress: 100 })) };
      const returnToken = crypto.randomUUID();
      save({ version: 1, path: location.pathname, expiresAt: Date.now() + lifetime, reference, brief,
        state: savedState, returnToken, stage: "prepared" });
      await window.SolariiUploads?.saveSessionForReturn();
      const fields = {
        "contact[email]": email,
        "contact[Phone]": phone,
        "contact[Request reference]": reference,
        "contact[Reference images]": photos.map(photo => photo.name + " — " + photo.remoteUrl).join("\n"),
        "contact[body]": "Inquiry reference: " + reference + "\n\n" + brief,
      };
      for (const [name, value] of Object.entries(fields)) {
        const input = form.elements.namedItem(name);
        if (!input) throw new Error("The inquiry form is incomplete. Please reload this page.");
        input.value = value;
      }
      const returnTo = new URL(location.href);
      returnTo.hash = "";
      // Shopify honours this exact URL after a successful contact POST. Without
      // contact_posted=true its Liquid form object renders posted_successfully? as false.
      returnTo.searchParams.set("contact_posted", "true");
      returnTo.searchParams.set("sq_return", returnToken);
      returnTo.searchParams.delete("form_type");
      const returnField = form.elements.namedItem("return_to");
      if (returnField) returnField.value = returnTo.pathname + returnTo.search;
      if (window.Shopify?.captcha?.protect) {
        await new Promise((resolve, reject) => {
          const timeout = setTimeout(() => reject(new Error("The security check did not finish. Please try again.")), 45000);
          window.Shopify.captcha.protect(form, () => { clearTimeout(timeout); resolve(); });
        });
      }
      // Preserve Shopify's native submit handling, CAPTCHA and success response.
      save({ ...pending, stage: "submitting" });
      form.requestSubmit();
    } catch (error) {
      sending = false;
      throw error;
    }
  }
  window.addEventListener("pageshow", event => {
    if (event.persisted) {
      receipt = readReceipt();
      if (receipt) { showReceipt(); return; }
      sending = false;
      window.dispatchEvent(new CustomEvent("solarii-inquiry-return"));
    }
  });
  window.SolariiInquiry = Object.freeze({
    get success() { return success; }, restore, submit,
    error: typeof result.error === "string" ? result.error : "",
  });
})();
